module.exports = __webpack_public_path__ + "static/media/uifaces15.4ea4db01.jpg";